import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';
import { UploadSKUDataGridService } from 'libs/features/src/lib/layout/organization-report/upload-sku-data/upload-sku-data-grid.service';

@Component({
  selector: 'piqet-angular-inline-tooltip',
  templateUrl: './inline-tooltip.component.html',
  styleUrls: ['./inline-tooltip.component.scss'],
})
export class InlineTooltipComponent {
  params: any;

  constructor(private router: Router, private uploadSKUDataGridService: UploadSKUDataGridService) {}

  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }

  onPrev(step: string) {}
}
